/**
 * Serialize gateway HTTP polls within a tab so bursts do not stack on the single-threaded backend.
 */

let _tail: Promise<void> = Promise.resolve();

export function runGatewayPoll<T>(fn: () => Promise<T>): Promise<T> {
  const run = _tail.then(() => fn());
  _tail = run.then(
    () => undefined,
    () => undefined,
  );
  return run;
}
